export enum GameType {
  LIMIT = 'limit',
  POT_LIMIT = 'pot_limit',
  NO_LIMIT = 'no_limit'
}

export enum TournamentStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  PAUSED = 'paused',
  BREAK = 'break',
  COMPLETED = 'completed'
}

export interface Round {
  id: string;
  minutes: number;
  smallBlind: number;
  bigBlind: number;
  ante: number;
  limit1?: number;
  limit2?: number;
  breakMinutes: number;
}

export interface Player {
  id: string;
  name: string;
  paid: boolean;
  rebuys: number;
  addOns: number;
  table: number;
  seat: number;
  timeOut?: Date;
  roundOut: number;
  rank: number;
  numberOfTableMoves: number;
  chips: number;
}

export interface Prize {
  id: string;
  description: string;
  amount: number;
  isFixed: boolean;
}

export interface TournamentSettings {
  name: string;
  notes: string;
  gameType: GameType;
  entryFee: number;
  startingChips: number;
  maxPlayersPerTable: number;
  fixedRake: number;
  perPlayerRake: number;
  currencySymbol: string;
  
  // Rebuy settings
  allowRebuys: boolean;
  rebuyFee: number;
  rebuyChips: number;
  disableRebuysAfterRound: number;
  applyRakeToRebuys: boolean;
  
  // Add-on settings
  allowAddOns: boolean;
  addOnFee: number;
  addOnChips: number;
  disableAddOnsAfterRound: number;
  applyRakeToAddOns: boolean;
  
  // Timer settings
  pauseBetweenRounds: boolean;
  handTimerDefaultSeconds: number;
}

export interface TournamentState {
  currentRound: number;
  secondsRemaining: number;
  accumulatedSeconds: number;
  status: TournamentStatus;
  startTime?: Date;
  endTime?: Date;
  pot: number;
  rake: number;
  totalEntries: number;
  activePlayers: number;
  totalRebuys: number;
  totalAddOns: number;
}

export interface Tournament {
  id: string;
  settings: TournamentSettings;
  rounds: Round[];
  players: Player[];
  prizes: Prize[];
  state: TournamentState;
  history: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface ClockState {
  isRunning: boolean;
  secondsRemaining: number;
  currentRound: number;
  isBreak: boolean;
  pauseCycle: number;
}

export interface SoundEvent {
  type: 'clockStart' | 'clockStop' | 'tournamentStart' | 'tournamentEnd' | 'warning' | 'finalCountdown';
  seconds?: number;
  soundName?: string;
}

export interface LayoutItem {
  id: string;
  type: string;
  text: string;
  position: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  style: {
    backgroundColor?: string;
    foregroundColor?: string;
    fontSize?: number;
    fontFamily?: string;
    bold?: boolean;
    italic?: boolean;
  };
}